function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/stable";
import "regenerator-runtime/runtime";
import React from "react";
import ReactDOM from "react-dom";
import { Redirect, Route, Router, Switch } from "react-router-dom";
import { syncHistoryWithStore } from "@superwf/mobx-react-router";
import browserHistory from "./config-history";
import "@sogei/react-web-components-catalog/dist/css/uikit.css";
import "@sogei/react-web-components-catalog/dist/css/uikit/it.css";
// import "Css/animate.css"
// import "Css/set.css"
import "Css/app.css";
import Home from "@/components/pages/home/Home";
import Cose from "@/components/pages/che-cosa-e/che-cosa-e";
import AcosaServe from "@/components/pages/a-cosa-serve/a-cosa-serve";
import Certificazione from "@/components/pages/certificazione/certificazione";
import BandiAvvisi from "@/components/pages/bandi-e-avvisi/bandi-e-avvisi";
import Organismi from "@/components/pages/organismi-certificatori/organismi-certificatori";
import News from "@/components/pages/news/news";
import NewsDetail from "@/components/pages/news/newsDetail/NewsDetail";
import Faq from "@/components/pages/faq/faq";
import Info from "@/components/pages/info/info";
import Cookies from "@/components/pages/cookies/cookies";
import PrivacyPolicy from "@/components/pages/privacy/privacy";
import { onNoServerResponse, onRequestConfig, onRequestConfigError, onResponse, onResponseError } from "@/services/network-config";
import RootStore from "./stores";
import StoreContext from "@/context/root-store";
import { AuthFooter, AuthHeader, AuthMenu, Messages, SpinnerCustom } from "@/containers/layout";
import Numeri from "./components/pages/numeri/numeri";
var $ = require("jquery");
var rootStore = new RootStore(onRequestConfig, onRequestConfigError, onResponse, onResponseError, onNoServerResponse);
// @ts-ignore
var history = syncHistoryWithStore(browserHistory, rootStore.routingStore);
var App = /*#__PURE__*/function (_React$Component) {
  function App(props) {
    var _this;
    _classCallCheck(this, App);
    _this = _callSuper(this, App, [props]);
    _defineProperty(_this, "unsubscribeFromStore", void 0);
    return _this;
  }
  _inherits(App, _React$Component);
  return _createClass(App, [{
    key: "componentDidMount",
    value: function componentDidMount() {}
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.unsubscribeFromStore) this.unsubscribeFromStore();
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AuthHeader, null), /*#__PURE__*/React.createElement(AuthMenu, null), /*#__PURE__*/React.createElement(SpinnerCustom, null), /*#__PURE__*/React.createElement(Messages, {
        extraClass: ["container-fluid", "py-3", "py-md-4"]
      }), /*#__PURE__*/React.createElement("main", {
        role: "main",
        id: "main"
      }, /*#__PURE__*/React.createElement(Switch, null, /*#__PURE__*/React.createElement(Route, {
        path: process.env.CONTEXT_PATH + "/home",
        render: function render() {
          return /*#__PURE__*/React.createElement(Home, null);
        }
      }), /*#__PURE__*/React.createElement(Route, {
        path: process.env.CONTEXT_PATH + "/che-cosa-e",
        render: function render() {
          return /*#__PURE__*/React.createElement(Cose, null);
        }
      }), /*#__PURE__*/React.createElement(Route, {
        path: process.env.CONTEXT_PATH + "/a-cosa-serve",
        render: function render() {
          return /*#__PURE__*/React.createElement(AcosaServe, null);
        }
      }), /*#__PURE__*/React.createElement(Route, {
        path: process.env.CONTEXT_PATH + "/certificazione",
        render: function render() {
          return /*#__PURE__*/React.createElement(Certificazione, null);
        }
      }), /*#__PURE__*/React.createElement(Route, {
        path: process.env.CONTEXT_PATH + "/contributi",
        render: function render() {
          return /*#__PURE__*/React.createElement(BandiAvvisi, null);
        }
      }), /*#__PURE__*/React.createElement(Route, {
        path: process.env.CONTEXT_PATH + "/numeri",
        render: function render() {
          return /*#__PURE__*/React.createElement(Numeri, null);
        }
      }), /*#__PURE__*/React.createElement(Route, {
        path: process.env.CONTEXT_PATH + "/organismi-di-certificazione",
        render: function render() {
          return /*#__PURE__*/React.createElement(Organismi, null);
        }
      }), /*#__PURE__*/React.createElement(Route, {
        path: process.env.CONTEXT_PATH + "/news",
        render: function render() {
          return /*#__PURE__*/React.createElement(News, null);
        }
      }), /*#__PURE__*/React.createElement(Route, {
        path: process.env.CONTEXT_PATH + "/news-detail",
        render: function render() {
          return /*#__PURE__*/React.createElement(NewsDetail, null);
        }
      }), /*#__PURE__*/React.createElement(Route, {
        path: process.env.CONTEXT_PATH + "/faq",
        render: function render() {
          return /*#__PURE__*/React.createElement(Faq, null);
        }
      }), /*#__PURE__*/React.createElement(Route, {
        path: process.env.CONTEXT_PATH + "/info",
        render: function render() {
          return /*#__PURE__*/React.createElement(Info, null);
        }
      }), /*#__PURE__*/React.createElement(Route, {
        path: process.env.CONTEXT_PATH + "/gestione-cookies",
        render: function render() {
          return /*#__PURE__*/React.createElement(Cookies, null);
        }
      }), /*#__PURE__*/React.createElement(Route, {
        path: process.env.CONTEXT_PATH + "/privacy-policy",
        render: function render() {
          return /*#__PURE__*/React.createElement(PrivacyPolicy, null);
        }
      }), /*#__PURE__*/React.createElement(Redirect, {
        to: process.env.CONTEXT_PATH + "/home"
      }))), /*#__PURE__*/React.createElement(AuthFooter, null));
    }
  }]);
}(React.Component);
ReactDOM.render(/*#__PURE__*/React.createElement(Router, {
  history: history
}, /*#__PURE__*/React.createElement(StoreContext.Provider, {
  value: {
    rootStore: rootStore
  }
}, /*#__PURE__*/React.createElement(App, null))), document.getElementById("root"));